import { useEffect, useState } from 'react'
import Modal from '@common/Modal'
import Button from '@UI/New/Button'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import Select from '@pages/Admin/CRM/components/base/Select/Select'
import { directionGroupApi, directionOrdersApi, usersAPI } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { IcoRemove } from '@/utils/icons'

const CourseAdditionalTeachersModal = ({
  open,
  order,
  franchiseId,
  onClose,
  onSuccess,
}) => {
  const addAlert = useAddAlert()
  const [teacherIds, setTeacherIds] = useState([])
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!open || !order) return

    const teachers = order.group_id
      ? order.group?.additionalTeachers ?? order.group?.additional_teachers
      : order.additionalTeachers ?? order.additional_teachers
    setTeacherIds(teachers?.map((teacher) => Number(teacher.id)) ?? [])
    setLoading(true)
    usersAPI
      .searchUsersForSelect({
        employeesOnly: 1,
        'per-page': '1000',
        ...(franchiseId ? { franchise_id: franchiseId } : {}),
      })
      .then((response) => setOptions(response?.data?.data ?? []))
      .catch(() => {
        setOptions([])
        addAlert({
          title: 'Ошибка',
          text: 'Не удалось загрузить список педагогов',
          type: 'error',
        })
      })
      .finally(() => setLoading(false))
  }, [addAlert, franchiseId, open, order])

  const handleSave = async () => {
    if (!order) return

    setSubmitting(true)
    try {
      if (order.group_id) {
        await directionGroupApi.updAdditionalTeachers({
          id: order.group_id,
          additional_teacher_ids: teacherIds,
        })
      } else {
        await directionOrdersApi.updAdditionalTeachers({
          id: order.id,
          additional_teacher_ids: teacherIds,
        })
      }
      addAlert({
        title: 'Успешно',
        text: 'Дополнительные педагоги обновлены',
        type: 'success',
      })
      onSuccess()
      onClose()
    } catch {
      addAlert({
        title: 'Ошибка',
        text: 'Не удалось обновить дополнительных педагогов',
        type: 'error',
      })
    } finally {
      setSubmitting(false)
    }
  }

  const primaryTeacherId = order?.group_id
    ? order?.group?.teacher_id
    : order?.teacher_id

  return (
    <Modal
      active={open}
      className={mclasses.modalWrapper}
      setActive={onClose}
    >
      <div className={mclasses.modalContainer}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>
              Дополнительные педагоги
            </span>
          </div>
          <div className={mclasses.closeIcon} onClick={onClose}>
            <IcoRemove />
          </div>
        </div>
        <div className={mclasses.formWrapper}>
          <p className={mclasses.label}>Педагоги</p>
          <Select
            mode="multiple"
            showSearch
            placeholder="Выберите педагогов"
            value={teacherIds}
            onChange={setTeacherIds}
            options={options.filter(
              (option) => Number(option.value) !== Number(primaryTeacherId),
            )}
            loading={loading}
            filterOption={(input, option) =>
              String(option?.label ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </div>
        <div className={mclasses.actions}>
          <Button color="gray" onClick={onClose}>
            Отменить
          </Button>
          <Button
            color="primary"
            onClick={handleSave}
            disabled={loading || submitting}
            isLoading={submitting}
          >
            Сохранить
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CourseAdditionalTeachersModal
